export default __webpack_public_path__ + "static/new-york-55705ffee4e7b1eda93e2a273151b7a4.svg";